import { TFrameAccordionWidth } from '@features/pages/typescript';
import theme from '@styles/theme';
export default {
  container: (isMargin: boolean, bg: string) => ({
    bg,
    width: '100%',
    display: 'flex',
    flexFlow: ['row wrap', 'row wrap', 'row wrap', 'row wrap', 'row nowrap'],
    p: isMargin ? ['16px 16px 32px', '16px 16px 32px', '16px 24px 40px', '16px 24px 40px', '16px 40px 48px'] : 0,
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  frame: (width: TFrameAccordionWidth) => {
    let maxFrameWidth = '100%';
    switch (width) {
      case 'half':
        maxFrameWidth = 'calc(50% -42px)';
        break;
      case 'third':
        maxFrameWidth = 'calc(33.333333% -42px)';
        break;
      case 'quarter':
        maxFrameWidth = 'calc(25% -42px)';
        break;
      default:
        break;
    }
    return {
      width: ['100%', '100%', '100%', '100%', maxFrameWidth]
    };
  }
};